//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/number_box'

//#endregion

import { ColumnModel } from '../../../../../api/api.models';
import { Enums } from '../../../../../../models/common';
import { GridTypes, GridController, GridOptions } from '../../../../../common/grid/grid.controller';
import { OpEquipmentQuantity } from '../../../../../../models/custom/op-equipment-quantity';
import { OpEquipmentType } from '../../../../../../models/custom/op-equipment-type';
import { OpPackage } from '../../../../../../models/core/op-package';
import { OrderService } from '../../../../../../services/order';
import { PopupHelper } from "../../../../../../helpers/popup-helper";
import { TypeHelper, LocalizationHelper } from "../../../../../../helpers";
import { OrderConfirmService } from '../../../../../../services/order/order.confirm.service';



export type ConfirmOrderDepositoryOpitons = {
    onInitialized: (ConfirmOrderInterface: IConfirmOrderDepository) => void
    orders: OpPackage[]
    minStates: OpEquipmentQuantity[]
    onOrdersUpdated: (source: OpPackage[]) => void
}

export interface IConfirmOrderDepository {
    hide: () => void
    setDataSource: (source: OpPackage[], minStates: OpEquipmentQuantity[]) => void
}

export class ConfirmOrderDepositoryController implements ng.IComponentController, IConfirmOrderDepository {

    // #region Consts

    public static get CONFIRM_ORDER_DEPOSITORY_GRID_NAME(): string { return 'ConfirmOrderDepositoryGrid' }
    public static get ID_LOCATION_KEY(): string { return 'loc1_10002_0' }
    public static get HELPER_LOCATION_NAME_KEY(): string { return 'loc1_1_0' }

    // #endregion

    // #region Memebers

    private options: ConfirmOrderDepositoryOpitons
    private popupOptions: DevExpress.ui.dxPopupOptions
    private popup: DevExpress.ui.dxPopover
    private gridOptions: GridOptions
    private gridController: GridController<any>
    private toolbarOptions: DevExpress.ui.dxToolbarOptions
    private ordersToProceed: number[]
    private minStates: OpEquipmentQuantity[]

    // #endregion

    // #region ng.IComponentController

    public $onInit() {
        this.initialize()
    }

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // #endregion


    // #region Ctor

    constructor(
        private orderService: OrderService,
        private confirmOrderService: OrderConfirmService
    ) { }

    // #endregion

    // #region Setup

    private initialize(): void {
        this.setMinStates()
        this.setPopupOptions()
        this.setDepositoryGrid(this.options.orders)
        this.setTooblarOptions()
        this.onInitialized()
    }

    private setMinStates() {
        if (this.options != null && this.options.minStates != null) {
            this.minStates = this.options.minStates
        }
    }

    // #endregions

    // #region Handle Orders

    private prepareNewOrdersToSave(orders: OpPackage[]): OpPackage[] {
        const loggedOperator = this.orderService.getLoggedOperator()

        return orders.map((order: OpPackage, index: number) => {
            const newOrder: OpPackage = new OpPackage(null)
            newOrder.dataList.setValue(order.depositoryLocation.idLocation, Enums.DataType.DEPOSITORY_ID)
            newOrder.contentList =  this.confirmOrderService.getContentList(this.getEquipmentQuantityElement(order))
            newOrder.idPackageStatus = Enums.PackageStatus.ToCompletion
            newOrder.name = loggedOperator.login + ': ' + (index + Date.now()).toString()
            newOrder.idOperatorCreator = loggedOperator.idOperator
            newOrder.idOperatorReceiver = null
            newOrder.creationDate = new Date(Date.now())
            newOrder.idDistributor = order.depositoryLocation.idDistributor
            newOrder.opState = Enums.OpChangeState.New
            newOrder.idPackage =  (index + 1) * -1 // nadaje paczce ujemne ID aby podczas walidacji grid ogarnia� kt�ry wiersz ma zaznaczy� 
            return newOrder
        })
    }


    private getEquipmentQuantityElement(pack: OpPackage): OpEquipmentQuantity {
        return _.find(this.minStates, (equipment: OpEquipmentQuantity) => {
            if (equipment.referenceValue != null && equipment.referenceValue.idLocation != null
                && pack != null && pack.depositoryLocation != null && pack.depositoryLocation.idLocation != null) {
                equipment.referenceValue.idLocation === pack.depositoryLocation.idLocation
                return equipment
            }
        })
    }

    // #endregion

    // #region Toolbar

    private setTooblarOptions(): void {
        this.toolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Continue),
                    onClick: (e: any) => {
                        const filteredOrders: OpPackage[] = this.ordersToProceed.map((id: number) => {
                            return _.find(this.options.orders, (order: OpPackage) => {
                                return order.idPackage == id
                            })
                        })

                        const updatedOrders: OpPackage[] = this.prepareNewOrdersToSave(filteredOrders)

                        this.onOrdersUpdated(updatedOrders)
                    }
                }
            }]
        }
    }

    // #endregion

    // #region Depository Grid

    private setDepositoryGrid(dataSource: OpPackage[]): any {
        if (this.gridController != null) {
            this.gridController.setDataSource(dataSource)
        } else {
            this.orderService
                .getConfirmOrderDepositoryColumns()
                .then((defaultColumns: ColumnModel[], columns: ColumnModel[]) => {
                    columns.push(this.getCheckBoxColumn())
                    defaultColumns.push(this.getCheckBoxColumn())

                    this.gridOptions = {
                        type: GridTypes.CREATE_EDIT,
                        name: ConfirmOrderDepositoryController.CONFIRM_ORDER_DEPOSITORY_GRID_NAME,
                        buttonsOptions: {
                            enabled: true
                        },
                        dataSource: dataSource,
                        dataSourceParser: this.getDepositoryLocationParser(),
                        columnsDictionary: columns,
                        defaultColumnsDictionary: defaultColumns,
                        onInitialized: (e, grid: GridController<any>) => {
                            this.gridController = grid
                        },
                        masterDetail: {
                            enabled: true,
                            autoExpandAll: true,
                            template: this.getMasterDetailTemplate(),
                        }
                    }
                })
        }
        this.ordersToProceed = dataSource.map((e: OpPackage) => e.idPackage)
    }

    private getMasterDetailTemplate(): (container: any, options: any) => void {
        return (container: any, options: any) => {
            const rowWidth: number = 738
            const element: OpEquipmentQuantity = this.getEquipmentFromSourceObject(options)
            if (element != null) {
                element.equipmentQuantity.forEach((equipment: OpEquipmentType, index: number) => {


                    const checkbox: any = this.getCheckBox(equipment, element)
                    const text: any = this.getText(equipment)
                    const input: any = this.getInput(equipment, element)
                    const row: any = this.getRow(rowWidth)

                    row.append(checkbox)
                    row.append(text)
                    row.append(input)

                    container.append(row)
                })
            }
        }
    }

    private getDepositoryLocationParser(): any {
        return (pack: OpPackage) => {
            return {
                additionalFields: [{
                    key: ConfirmOrderDepositoryController.ID_LOCATION_KEY,
                    value: (pack != null && pack.depositoryLocation != null) ? pack.depositoryLocation.idLocation : null
                }, {
                    key: ConfirmOrderDepositoryController.HELPER_LOCATION_NAME_KEY,
                    value: (pack != null && pack.depositoryLocation != null) ? pack.depositoryLocation.name : null
                }],
            }
        }
    }

    private getCheckBoxColumn(): any {
        const removeItem: ColumnModel = <any>{

            idName: 'add',
            name: 'Add',
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
            type: Enums.DataTypeClass.Text,
            cellTemplate: (container: any, options: any) => {
                const a = $(container)
                a.css({ 'justify-content': 'center', 'display': 'flex' })
                if (options.data.referenceType != "" /*&& !options.data.isNew*/) {
                    const checkBoxOptions: DevExpress.ui.dxCheckBoxOptions = {
                        hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
                        onValueChanged: (e: any): any => {
                            setTimeout(() => {
                                this.onCheckBoxValueChanged(e.value)
                            }, 50)
                        },
                        value: true
                    }
                    let button = $('<div ></div>')
                    button.dxCheckBox(checkBoxOptions)
                    button.appendTo(container)
                }
            }
        }
        return removeItem
    }

    private onCheckBoxValueChanged(isSelected: boolean): void {
        if (this.gridController != null && this.gridController.selectedItemId != null) {
            const selectedItem: number = this.gridController.selectedItemId
            if (isSelected === true) {
                this.ordersToProceed.push(selectedItem)
            }
            else if (isSelected === false) {
                this.ordersToProceed.splice(this.ordersToProceed.indexOf(selectedItem), 1);
            }
        }
    }

    // #endregion

    // #region Master Detail

    private getEquipmentFromSourceObject(source: any): OpEquipmentQuantity {
        return _.find(this.minStates, (equipment: OpEquipmentQuantity) => {
            const element: OpPackage = this.orderService.getSourceObjectFromGridObject<OpPackage>(source.data) as OpPackage
            const locationId: number = element.depositoryLocation.getReferenceKey()
            const referenceValueId: number = equipment.referenceValue.getReferenceKey()
            return locationId === referenceValueId
        })
    }

    private getCheckBox(equipment: OpEquipmentType, element: OpEquipmentQuantity): any {
        return $('<div></div>')
            .css({
                'flex-grow': '1',
                'width': '100%',
                'flex-basis': '200px'
            })
            .dxCheckBox({
                value: true,
                onValueChanged: (e) => {
                    const numberBox = (e.element.parent().children('.dx-numberbox').first()).dxNumberBox("instance")
                    if (e.value === false) {
                        numberBox.option({
                            value: 0,
                            disabled: true
                        })
                    } else {
                        numberBox.option({
                            value: equipment != null && equipment.quantity != null ? equipment.quantity : 0,
                            disabled: false
                        })
                    }
                    this.updateMinStates(element, equipment, e.value)
                }
            })
    }

    private getText(equipment: OpEquipmentType): any {
        return $('<div></div>')
            .css({
                'flex-grow': '1',
                'width': '100%'
            })
            .text(equipment.article.toString())

    }

    private getRow(rowWidth: number): any {
        return $('<div></div>')
            .css({
                'display': 'flex',
                'max-width': rowWidth - 100 + 'px'
            }).click(e => {
            })
    }

    private getInput(equipment: OpEquipmentType, element: OpEquipmentQuantity): any {
        return $('<div></div>')
            .css({
                'flex-grow': '1',
                'width': '120px'
            })
            .dxNumberBox({
                min: 0,
                showSpinButtons: true,
                value: equipment != null && equipment.quantity != null ? equipment.quantity : 0,
                onValueChanged: (e: any) => {
                    this.updateMinStates(element, equipment, e.value)
                }
            })
    }

    private updateMinStates(source: OpEquipmentQuantity, sourceEquipmentElement: OpEquipmentType, value: number | boolean): void {
        if (this.isNotNull(sourceEquipmentElement)) {
            if (typeof value === 'number') {
                const elementToUpdate: OpEquipmentQuantity = this.getElementToUpdate(source)
                if (elementToUpdate != null) {
                    const articleToUpdate: OpEquipmentType = this.getArticleToUpdate(elementToUpdate, sourceEquipmentElement)
                    if (articleToUpdate != null) {
                        articleToUpdate.quantity = value
                    }
                }
            }

            if (typeof value === 'boolean') {
                const elementToUpdate: OpEquipmentQuantity = this.getElementToUpdate(source)
                if (elementToUpdate != null) {
                    const articleToUpdate: OpEquipmentType = this.getArticleToUpdate(elementToUpdate, sourceEquipmentElement)

                    if (articleToUpdate == null && value === true) {
                        elementToUpdate.equipmentQuantity.push(sourceEquipmentElement)
                    } else if (articleToUpdate != null && value === false) {
                        const index: number = elementToUpdate.equipmentQuantity.indexOf(sourceEquipmentElement)
                        elementToUpdate.equipmentQuantity.splice(index, 1);
                    }
                }
            }
        } else {
            console.warn('Source cant be null')
        }
    }

    private getArticleToUpdate(elementToUpdate: OpEquipmentQuantity, sourceEquipmentElement: OpEquipmentType) {
        return _.find(elementToUpdate.equipmentQuantity, (e: OpEquipmentType) => {
            if (this.isNotNull(e)) {
                return e.article.idArticle == sourceEquipmentElement.article.idArticle
            }
        })
    }
    private getElementToUpdate(source: OpEquipmentQuantity): OpEquipmentQuantity {
        return _.find(this.minStates, (e: OpEquipmentQuantity) => {
            if (this.isNotNull(e)) {
                return e.referenceValue.idLocation == source.referenceValue.idLocation
            }
        })
    }

    private isNotNull(object: OpEquipmentType | OpEquipmentQuantity): boolean {
        if (object instanceof OpEquipmentType) {
            return object != null && object.article != null && object.article.idArticle != null
        }

        if (object instanceof OpEquipmentQuantity) {
            return object != null && object.referenceValue != null && object.referenceValue.idLocation != null
        }
    }

    // #endregion

    // #region Popup

    private setPopupOptions(): void {
        this.popupOptions = PopupHelper.mergeWithDefaultOptions({
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectDepository),
            width: '800',
            height: '800',
            onInitialized: (e: any) => {
                this.popup = e.component
                this.show()
            }
        })
    }

    private show(): void {
        this.popup.show()
    }

    // #endregion

    // #region events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private onOrdersUpdated(updatedOrders: OpPackage[]): void {
        if (this.options != null && _.isFunction(this.options.onOrdersUpdated)) {
            this.options.onOrdersUpdated(updatedOrders)
        }
    }

    // #endregion 

    // #region IConfirmOrderDepository Implementation

    public setDataSource(source: OpPackage[], minStates: OpEquipmentQuantity[]): void {
        this.show()
        if (_.size(source) > 0) {
            this.minStates = minStates
            this.options.orders = []
            this.options.orders = source
            this.setDepositoryGrid(source)
        }
    }

    public hide() {
        this.popup.hide()
    }

    // #endregion
}